import React from 'react';

import { RequirementEntity } from 'Models/Entities';

import { Display, QuickTypes } from 'Views/Components/Button/Button';
import	WizardSteps, {
	WizardStepsButton,
} from 'Views/Pages/Frontend/StudyPlanWizard/WizardSteps';

interface ICourseSelectionPageFooter {
	components: RequirementEntity[]
	currentComponentId: string | undefined,
	nextStep: () => any,
	previousStep: () => void,
	setCurrentComponentId: (value: React.SetStateAction<string | undefined>) => void,
}

const CourseSelectionPageFooter = ({
	components, currentComponentId, nextStep, previousStep, setCurrentComponentId,
}: ICourseSelectionPageFooter) => {
	const currentComponentIndex = components
		.findIndex(component => component.id === currentComponentId);

	const isLastComponent = currentComponentIndex === (components.length - 1);

	const backButtonAction = currentComponentIndex === 0
		? () => previousStep()
		: () => setCurrentComponentId(components[currentComponentIndex - 1].id);

	const footerButtons: WizardStepsButton[] = [
		{
			title: 'Back',
			quickTypes: QuickTypes.Secondary,
			icon: {
				icon: 'arrow-back',
				iconPos: 'icon-left',
			},
			onClick: backButtonAction,
		},
		{
			title: 'Next',
			display: Display.Solid,
			icon: {
				icon: 'arrow-forward',
				iconPos: 'icon-right',
			},
			onClick: () => {
				if (isLastComponent) {
					nextStep();
				} else {
					const nextComponentId = components[currentComponentIndex + 1].id;
					setCurrentComponentId(nextComponentId);
				}
			},
		},
	];

	return <WizardSteps rightButtons={footerButtons} />;
};

export default CourseSelectionPageFooter;
